import React, { useEffect, useState } from "react";
import Footer from "../../Base/Footer";
import Header from "../../Base/Header";
import Playlist from "../../Components/PlaylistView/Playlist";
import ReactPaginate from "react-paginate";
import styles from "../../Styles/Playlist/playlist.module.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { makeStyles } from "@mui/styles";
import { getFilteredPlaylists } from "../../helper/Playlists/playlist";
import { getAllCategories } from "../../helper/categoryApiCalls/category";
import Categories from "./Categories";
import { getAllCreators } from "../../helper/creatorsApiCalls/creator";
import Creators from "./Creators";
import Languages from "./Languages";
import RadioBox from "./radioBox";
import { rating } from "./Rating";
import filter from "../../images/filter.svg";
import FilterModal from "../../Components/Modals/FilterModal";
import Loader from "react-js-loader";
import { getRandomOpportunity } from "../../helper/opportunity";
import OppSlider from "../../Components/Opportunity/oppSlider";
import OpportunityPop from "../../Components/Opportunity/opportunityPop";
import { toast, ToastContainer } from "react-toastify";
import { useTheme } from "../../Context/ThemeContext";

const useStyles = makeStyles({
  root: {
    width: "100%",
    border: "none",
    outline: "none",
    color: "var(--text-primary) !important",
    backgroundColor: "var(--bg-secondary) !important",
    "& .MuiAccordionSummary-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiTypography-root": {
      color: "var(--text-primary) !important",
    },
    "& .MuiSvgIcon-root": {
      color: "var(--text-primary) !important",
    },
  },
  summary: {
    backgroundColor: "transparent",
    color: "var(--text-primary) !important",
    "& .MuiSvgIcon-root": {
      color: "var(--text-primary) !important",
    },
  },
});

const Playlists = () => {
  const names = [
    "English",
    "Hindi",
    "Marathi",
    "Konkani",
    "Bengali",
    "Tamil",
    "Kannada",
    "German",
    "Chinese",
    "Telugu",
  ];

  const classes = useStyles();
  const { theme } = useTheme();

  const [playlists, setPlaylists] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [loading, setLoading] = useState(null);
  const [loading2, setLoading2] = useState(null);
  const [category, setCategory] = useState([]);
  const [creators, setCreators] = useState([]);
  const [error, setError] = useState("");
  const [myFilters, setMyFilters] = useState({
    filters: {
      category: [],
      creator: [],
      subCategory: [],
      language: [],
      rating: [],
    },
  });

  const [randOpportunity1, setRandOpportunity1] = useState([]);
  const [selectedOpportunity, setSelectedOpportunity] = useState();
  const [isOpen, setIsOpen] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  const loadFilteredPlaylists = () => {
    setError("");
    setLoading(true);

    let body = {
      languages: myFilters.filters.language,
      rating: myFilters.filters.rating[0],
    };
    let limit = 6;

    getFilteredPlaylists("all", currentPage, limit, "newest", body).then(
      (data) => {
        if (data.success === "false") {
          setError(data.message);
        } else {
          const totalPageCount = Math.ceil(data.data.total / limit);
          setTotalPageCount(totalPageCount);
          setPlaylists(data?.data?.playlist);
          setLoading(false);
        }
      },
    );
  };

  async function getRandOpp() {
    const playlist = await getRandomOpportunity();
    if (playlist.success === true) {
      setLoading2(false);
      let array1 = playlist?.data[0];
      let array2 = playlist?.data[1];
      if (array2) array1 = array1.concat(array2);
      setRandOpportunity1(array1 || []);
    }
  }

  useEffect(() => {
    getRandOpp();
  }, []);

  function loadAllCategories() {
    setError("");
    getAllCategories().then((data) => {
      if (data.status === "fail") setError(data.message);
      else setCategory(data.data);
    });
  }

  function loadAllCreators() {
    setError("");
    getAllCreators().then((data) => {
      if (data.status === "fail") setError(data.message);
      else setCreators(data);
    });
  }

  const handleFilters = (filters, filterBy) => {
    const newFilters = { ...myFilters };
    newFilters.filters[filterBy] = filters;

    if (filterBy === "rating") {
      newFilters.filters[filterBy] = handleRating(filters);
    }

    loadFilteredPlaylists();
    setMyFilters(newFilters);
  };

  const handleRating = (value) => {
    let newArray = [];
    for (let key in rating) {
      if (rating[key]._id === parseInt(value)) {
        newArray = rating[key].array;
      }
    }
    return newArray;
  };

  useEffect(() => {
    loadFilteredPlaylists();
    loadAllCategories();
    loadAllCreators();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myFilters.filters, currentPage]);

  const PlaylistsPage = () => (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <h2>Playlists</h2>
        <img
          src={filter}
          alt="filter"
          className={styles.filtericon}
          style={{
            filter: theme === "dark" ? "invert(1)" : "none",
            WebkitFilter: theme === "dark" ? "invert(1)" : "none",
          }}
          onClick={() => setOpen((val) => !val)}
        />
      </div>

      {loading && (
        <Loader
          type="bubble-top"
          bgColor={theme === "dark" ? "#ffffff" : "#000000"}
          size={50}
          color={theme === "dark" ? "#ffffff" : "#000000"}
          title="Loading Playlists"
        />
      )}

      <main className={styles.main}>
        <aside className={`${styles.left} hella`}>
          <p>Filters</p>

          <Accordion className={classes.root}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Ratings</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <RadioBox
                rating={rating}
                handleFilters={(filters) => handleFilters(filters, "rating")}
                filters={myFilters.filters}
              />
            </AccordionDetails>
          </Accordion>

          <Accordion className={classes.root}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography>Languages</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Languages
                handleFilters={(filters) => handleFilters(filters, "language")}
                languages={names}
                filters={myFilters.filters}
              />
            </AccordionDetails>
          </Accordion>
        </aside>

        {playlists.length > 0 ? (
          <div className={styles.pagedata}>
            {playlists.map((playlist, index) => (
              <Playlist key={index} data={playlist} />
            ))}
          </div>
        ) : (
          !loading && (
            <div className={styles.pagedata}>
              <span className={styles.noplaylist}>
                {error || "No playlists found"}
              </span>
            </div>
          )
        )}
      </main>

      {totalPageCount > 1 && (
        <ReactPaginate
          previousLabel={"← "}
          nextLabel={" →"}
          breakLabel={"..."}
          pageCount={totalPageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={(event) => setCurrentPage(event.selected + 1)}
          containerClassName={styles.pagination}
          pageClassName={styles.pageItem}
          pageLinkClassName={styles.pageLink}
          previousClassName={styles.pageItem}
          nextClassName={styles.pageItem}
          activeClassName={styles.active}
        />
      )}

      <div className="w-full h-full pt-6 mt-4 px-6 rounded-t-lg bg-[color:var(--bg-primary)] text-[color:var(--text-primary)] text-lg font-[600]">
        Some Curated Opportunities
      </div>

      {loading2 && (
        <Loader
          type="bubble-top"
          bgColor={theme === "dark" ? "#ffffff" : "#000000"}
          size={50}
          color={theme === "dark" ? "#ffffff" : "#000000"}
          title="Loading Opportunities"
        />
      )}

      {randOpportunity1.length > 0 ? (
        <>
          <OppSlider
            heading={randOpportunity1[0]?.category}
            playlist={randOpportunity1}
            setSelectedOpportunity={setSelectedOpportunity}
            openModal={openModal}
          />
          {selectedOpportunity && (
            <OpportunityPop
              selectedOpportunity={selectedOpportunity}
              closeModal={closeModal}
              isOpen={isOpen}
              toast={toast}
            />
          )}
        </>
      ) : (
        <div className="pt-3">No Opportunities Found</div>
      )}

      {open && (
        <FilterModal
          open={open}
          setOpen={setOpen}
          category={category}
          creators={creators}
          handleFilters={handleFilters}
          loadFilteredPlaylists={loadFilteredPlaylists}
          handleRating={handleRating}
          names={names}
          filters={myFilters.filters}
        />
      )}
    </div>
  );

  return (
    <>
      <ToastContainer />
      <Header />
      {PlaylistsPage()}
      <Footer />
    </>
  );
};

export default Playlists;
